// 引入web.css
import '../../assets/style/web.css'
import { UTILS } from '../utils';
import { DATA } from '../data';
var CONFIG = {
    platform: 'web',
    
    // 本地开发环境URL配置:
    // web_url: 'https://wx.yxdxt.com:8080',
    // qq_url: 'http://wx.yxdxt.com/qq',
    // wechat_url: 'http://wx.yxdxt.com/',

    // 预发布环境URL配置:
    // web_url: 'https://bpre.yxdxt.com',
    // qq_url: 'https://qq.yxdxt.com/qq',
    // wechat_url: 'https://prewx.yxdxt.com/',

    // 正式环境URL配置:
    web_url: 'https://b.yxdxt.com',
    qq_url: 'https://qq.yxdxt.com/qq',
    wechat_url: 'https://wx.yxdxt.com',

    // api接口地址
    api_url: 'https://api.yxdxt.com/api',
    platform_params: {
        platform: 4,
        version: '1.5.0',
        time: (new Date()).getTime() / 1000
    },

    // 协议地址
    agree_url: 'http://wx.yxdxt.com/agreement/index.html',
    privacy_url: 'http://wx.yxdxt.com/agreement/privacy.html',

    // 扫码下载地址
    // ios_durl: 'https://testflight.apple.com/join/bdPtq3I0',
    ios_durl: 'https://apps.apple.com/cn/app/%E5%A4%A9%E6%97%B6%E5%AD%90%E5%B9%B3%E7%94%9F%E8%BE%B0%E5%85%AB%E5%AD%97-%E5%91%BD%E7%90%86%E7%B2%BE%E5%93%81/id1471841010',
    android_durl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.muhuo.bz&fromcase=40002',
    // ios_durl: 'http://suo.im/5F0NEI',
    // android_durl: 'http://suo.im/695Gqp',
    // 应用宝地址
    download_url: 'https://sj.qq.com/myapp/detail.htm?apkName=com.muhuo.bz',
    // 备案号链接地址
    icp_url: 'https://beian.miit.gov.cn/',
    
    // 拼接微信分享地址
    getWechatShareUrl(id) {
        var shareUrl = CONFIG.wechat_url + '/share/famouspediaread/' + id + '/famouspedia';
        console.error('getWechatSahreUrl------', shareUrl)
        return shareUrl;
    },
    // 拼接微信登录授权地址
    getWechatAuthUrl() {
        var wechatBathUrl = 'https://b.yxdxt.com',
            wechatAuthUrl = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx363a0062fab92b0b';
        wechatAuthUrl = wechatAuthUrl + '&redirect_uri=' + window.encodeURIComponent(wechatBathUrl);
        wechatAuthUrl = wechatAuthUrl + '&response_type=code&scope=snsapi_login&state=web#wechat_redirect';
        console.log('wechatAuthUrl---', wechatAuthUrl)
        return wechatAuthUrl;
    },
    // 拼接QQ登录授权地址
    getQQAuthUrl() {
        var path = UTILS.getQueryString('path'),
            qqBaseUrl = "https://qq.yxdxt.com/qq",
            qqAuthUrl = "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101875950&redirect_uri=";
        qqAuthUrl = qqAuthUrl + window.encodeURIComponent(path ? qqBaseUrl + '?path=' + path : qqBaseUrl);
        qqAuthUrl = qqAuthUrl + "&state=web&scope=get_user_info&display=default";
        console.log("qqAuthUrl---", qqAuthUrl)
        return qqAuthUrl;
    },
    getQQShareUrl(info) {
        // http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={{URL}}&title={{TITLE}}&desc={{DESC}}&summary={{SUMMARY}}&site={{SOURCE}}&pics={{IMAGE}}
        var famousBaziInfo = AppFate.$store.state.famouspedia.curPediaBaziInfo;
        var shareUrl = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=";
            shareUrl = shareUrl + encodeURIComponent(CONFIG.qq_url + '/?path=share-famouspediaread-' + famousBaziInfo.id + '-famouspedia')
            shareUrl = shareUrl + '&title=';
            shareUrl = shareUrl + DATA.getFamousPediaShareTextByData('qq', info) + '&desc=点击可查看名人生平事迹及与之对应的各位易友的论断。&pics=';
            shareUrl = shareUrl + CONFIG.qq_url + '/dist/share-img-5.png' + '';
        return shareUrl;
    }
    
}

export {
    CONFIG
}